// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"site_wrapper_3RoH0","top":"site_top_1WPu9","bottom":"site_bottom_BD-IU"};